import React from "react";

const MarkdownCode = ({ node, className, ...props }: any) => {
  const isBlock = className && className.startsWith("language-");
  return (
    <code
      className={`${
        isBlock
          ? "block bg-gray-900 text-gray-100 p-4 overflow-x-auto rounded-lg"
          : "inline bg-gray-200 text-gray-900 px-1 py-0.5 rounded"
      } font-mono text-sm`}
      {...props}
    >
      {props.children}
    </code>
  );
};

export default MarkdownCode;
